// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__I9aC9","content":"GlobalSearch_content__2Pn_W"};